import BreakdownCard, {
  BreakdownRow,
} from "@/components/molecules/cards/dashboard/BreakdownCard";
import { DashboardCompanyStatsResponse } from "@/interfaces/DashboardCompanyStats";
import { useGetDashboardCompanyStatsQuery } from "@/services/admin/dashboardCompanyStats";
import { FC } from "react";
import { Col, Row } from "react-bootstrap";

const PALETTE = [
  "#2c7be5",
  "#27bcfd",
  "#00d27a",
  "#f5803e",
  "#e63757",
  "#9da9bb",
  "#748194",
  "#a16eff",
  "#fac620",
  "#3874ff",
];

const CompanyStatsSection: FC = () => {
  const { data, isFetching } = useGetDashboardCompanyStatsQuery();

  const statusRows: BreakdownRow[] = (data?.byStatus.rows ?? []).map((row) => ({
    key: row.statusId,
    label: row.statusName,
    color: row.backgroundColor,
    count: row.count,
  }));

  const sectorRows: BreakdownRow[] = (data?.byActivitySector.rows ?? []).map(
    (row, index) => ({
      key: row.sectorId,
      label: row.sectorName,
      color: PALETTE[index % PALETTE.length],
      count: row.count,
    }),
  );

  const opcoRows: BreakdownRow[] = (data?.byOpco.rows ?? []).map((row) => ({
    key: row.opcoId,
    label: row.opcoName,
    color: row.backgroundColor,
    count: row.count,
  }));

  return (
    <Row className="g-3">
      <Col md={4}>
        <BreakdownCard
          title="Par Statut d'entreprise"
          metric="count"
          rows={statusRows}
          grandCount={data?.byStatus.grandCount ?? 0}
          isLoading={isFetching}
        />
      </Col>
      <Col md={4}>
        <BreakdownCard
          title="Par Secteur d'activité"
          metric="count"
          rows={sectorRows}
          grandCount={data?.byActivitySector.grandCount ?? 0}
          isLoading={isFetching}
        />
      </Col>
      <Col md={4}>
        <BreakdownCard
          title="Par Opco"
          metric="count"
          rows={opcoRows}
          grandCount={data?.byOpco.grandCount ?? 0}
          isLoading={isFetching}
        />
      </Col>
    </Row>
  );
};

export default CompanyStatsSection;
